import { defineStore } from "pinia";
import { useNuxtApp } from "#app";
import { useAuthStore } from "~/stores/AuthStore";

export const useTicketStore = defineStore("ticketStore", {
  state: () => ({
    eventId: null,
    tickets: [],
    premiumMemberships: [],
  }),
  getters: {
    ticketsSold: function () {
      return this.tickets.length;
    },
    ticketsScanned: function () {
      return Object.values(this.tickets).filter(
        (ticket) => ticket.scanned_at !== null
      ).length;
    },
    premiumEntries: function () {
      return Object.values(this.premiumMemberships).filter(
        (membership) => membership.scanned_at !== null
      ).length;
    },
  },
  actions: {
    getTickets: async function (eventId) {
      const store = useTicketStore();

      store.eventId = eventId;

      const authStore = useAuthStore();
      const { $api } = useNuxtApp();

      const response = await $api
        .get("/event/" + eventId + "/tickets", {
          headers: {
            Authorization: "Bearer " + authStore.token,
          },
        })
        .then(function (response) {
          store.tickets = response.data.tickets.data;
          store.premiumMemberships = response.data.premiumMemberships;
        })
        .catch(function (error) {
          // throw error;
        });
    },
    updateTicket: async function (ticketUuid) {
      const authStore = useAuthStore();
      const { $api } = useNuxtApp();

      const response = await $api
        .patch(
          "/ticket/" + ticketUuid,
          {},
          {
            headers: {
              Authorization: "Bearer " + authStore.token,
            },
          }
        )
        .then(function (response) {
          store.tickets = response.data.data;
        })
        .catch(function (error) {
          // throw error;
        });
    },
    premiumEntry: async function (eventId, ref) {
      const authStore = useAuthStore();
      const { $api } = useNuxtApp();
      try {
        const response = await $api.post(
          "/event/" + eventId + "/vip",
          { ref },
          {
            headers: { Authorization: "Bearer " + authStore.token },
            timeout: 10000,
          }
        );
        const memberships = response.data;
        const member = memberships.find((membership) => membership.ref === ref);
        if (!member) {
          throw new Error("The server did not confirm this membership.");
        }
        if (this.eventId === eventId) {
          this.premiumMemberships = memberships;
        }
        return {
          result: "scanSuccess",
          message: "Black Card Holder",
          subMessage: member.name,
          avatar: member.avatar || null,
          showMoreName: null,
        };
      } catch (error) {
        const status = error.response?.status;
        const duplicate =
          status === 409 ||
          (status === 401 &&
            error.response?.data?.message === "Already scanned");
        return {
          result: "fail",
          message: duplicate
            ? "Already Scanned"
            : status === 403 || status === 422
            ? "Membership not valid for this event"
            : "Unable to verify card",
          subMessage:
            duplicate || status === 403 || status === 422
              ? null
              : "Check the connection and try again.",
          avatar: null,
          showMoreName: null,
        };
      }
    },

    async scanTicket(ticketRefUnescaped) {
      const ticketRef = ticketRefUnescaped.replace(/['"]+/g, "").trim();
      if (ticketRef.startsWith("premium::")) {
        return this.premiumEntry(this.eventId, ticketRef);
      }

      let ticket = this.tickets.find(
        (t) => t.ref.trim() === String(ticketRef).trim()
      );

      if (ticket === undefined || ticket === null) {
        return {
          result: "fail",
          message: "Ticket Not Found",
          subMessage: null,
          showMoreName: null,
        };
      }

      let ticketsLeft = this.tickets.filter((t) => {
        return t.name === ticket.name && t.scanned_at === null;
      });

      if (ticket.scanned_at !== null) {
        return {
          result: "fail",
          message: "Already Scanned",
          subMessage: ticket.scanned_at.toLocaleString(),
          showMoreName:
            ticketsLeft.length > 0 ? Object.values(ticketsLeft)[0].name : null,
        };
      }

      ticket.scanned_at = new Date();
      this.updateTicket(ticket.uuid);

      ticketsLeft = this.tickets.filter((t) => {
        return t.name === ticket.name && t.scanned_at === null;
      });

      return {
        result: "scanSuccess",
        message: "Scanned!",
        subMessage:
          "(" + ticket.name + " : " + ticketsLeft.length + " remaining)",
        showMoreName:
          ticketsLeft.length > 0 ? Object.values(ticketsLeft)[0].name : null,
      };
    },
    searchTickets(query) {
      console.log(query);
    },
  },
});
